<template>
    <section class="textSection">
        <div>
            <h1>Récupération</h1>
            <form class="recover-form" v-on:submit.prevent="sendEmail()">
                <div class="recover-container">
                    <div v-if="error"class="recover-errors">
                        <p class="recover-error">Le courriel spécifié n'existe pas</p>
                    </div>
                    <p v-if="submitted" class="recover-submitted">Vous recevrez d'ici peu un email pour pouvoir réinitialiser votre mot de passe</p>
                    <label class="recover-label" for="user_email">Courriel *</label>
                    <input class="recover-input" :style="[error === true ? {'border-color': 'red'} : '']" v-model="email" type="email" placeholder="Email" autofocus="autofocus" required="required" aria-required="true" id="user_email">
                </div>
                <button class="recover" type="submit">M'envoyer les instructions par email</button>
            </form>
        </div>
    </section>
</template>

<script>
    import AuthenticationService from '../services/authentication.js'
    export default {
        name: "recover",
        data: function () {
            return {
                email: null,
                submitted: false,
                error: false,
            }
        },

        methods: {
            sendEmail: function() {
                AuthenticationService.recover(this.email).then((res) => {
                    this.submitted = true;
                    this.error = false;
                }, (res) => {
                    this.submitted = false;
                    this.error = true;
                });
                this.email = null;
            }
        }
    }
</script>

<style>

    .recover-form {
        padding: 0 15%;
        text-align: start;
    }

    .recover-errors {
        border: 1px solid red;
        padding-left: 5px;
        margin-bottom: 10px;
    }

    .recover-error {
        color: red;
        font-weight: bold;
        font-size: 16px;
        margin: 5px;
    }

    .recover-submitted {
        font-size: 18px;
    }

    .recover-label {
        font-weight: bold;
    }

    .recover-container {
        margin-bottom: 10px ;
    }

    .recover-input {
        margin-top: 5px;
        width: 100%;
        padding: 10px 5px;
        background-color: #fafafa;
        border-radius: 2px;
        font-size: 16px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.4);
        box-shadow: inset 0 1px 2px rgba(0,0,0,.4);
    }

    .recover-input:focus {
        outline: none;
    }

    .recover {
        color: #fff;
        background-color: #0f3274;
        padding: 10px 12px;
        border: none;
        border-radius: 3px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// Recover.vue?3c6ff248